import { useEffect, useRef } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

export default function useZoom(enabled = false) {
  const { camera, gl } = useThree();
  const zoomFOV = useRef(50); // FOV inicial
  const lastTouchDistance = useRef(0);

  useEffect(() => {
    if (!enabled) return;

    // Wheel para desktop
    const handleWheel = (event) => {
      event.preventDefault();
      const delta = event.deltaY * 0.05;
      zoomFOV.current = THREE.MathUtils.clamp(
        zoomFOV.current + delta,
        30, // min FOV (más zoom)
        75  // max FOV (menos zoom)
      );
      camera.fov = zoomFOV.current;
      camera.updateProjectionMatrix();
    };

    // Pinch para móvil
    const handleTouchMove = (event) => {
      if (event.touches.length === 2) {
        event.preventDefault();
        
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        
        const dx = touch2.clientX - touch1.clientX;
        const dy = touch2.clientY - touch1.clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (lastTouchDistance.current > 0) {
          const delta = lastTouchDistance.current - distance;
          zoomFOV.current = THREE.MathUtils.clamp(
            zoomFOV.current + delta * 0.1,
            30, // min FOV (más zoom)
            75  // max FOV (menos zoom)
          );
          camera.fov = zoomFOV.current;
          camera.updateProjectionMatrix();
        }
        
        lastTouchDistance.current = distance;
      }
    };

    const handleTouchEnd = () => {
      lastTouchDistance.current = 0;
    };

    const element = gl.domElement;
    element.addEventListener('wheel', handleWheel, { passive: false });
    element.addEventListener('touchmove', handleTouchMove, { passive: false });
    element.addEventListener('touchend', handleTouchEnd);

    return () => {
      element.removeEventListener('wheel', handleWheel);
      element.removeEventListener('touchmove', handleTouchMove);
      element.removeEventListener('touchend', handleTouchEnd);
    };
  }, [enabled, gl, camera]);
}
